import React, { Component, PropTypes } from 'react';
import * as B from 'react-bootstrap';
import Errorable from 'components/lib/Errorable/';
import Loadable from 'components/lib/Loadable/';
import { CHAT_PART } from 'actions/chat';
import { WEB_RTC_FEATURES } from 'actions/chat/webrtc';
import { WEB_RTC_DEVICE_KIND } from 'reducers/chat/webrtc';
import '../styles/audio.scss';

// As with VideoChat, be carefull with the elements mutated by OT

class AudioChat extends Component {
  static propTypes = {
    loading: PropTypes.bool.isRequired,
    height: PropTypes.number.isRequired,
    established: PropTypes.bool.isRequired,
    audioEstablishingLabel: PropTypes.string.isRequired,
    audioEstablishedLabel: PropTypes.string.isRequired,
    webRTCSubscriberConfiguration: PropTypes.object,
    webRTCPublisherConfiguration: PropTypes.object,
    invokeOnWebRTC: PropTypes.func.isRequired,
    onClientError: PropTypes.func.isRequired,
    onEndWebRTC: PropTypes.func.isRequired,
  };
  get wraperRendering() {
    return { height: this.props.height + 'px' };
  }
  get label() {
    return this.props.established ? this.props.audioEstablishedLabel : this.props.audioEstablishingLabel;
  }
  render() {
    let wraperClassName = 'chat-video-wraper',
        endClassName = 'chat-audio-btn chat-audio-end'
          + (this.props.established ? '' : ' establishing');

    return (
      <div className="chat-audio-wraper" style={this.wraperRendering}>
        <div id="chat-webtrc-agent" className="audio"></div>
        <div id="chat-webtrc-customer" className="audio"></div>
        <B.Button
          onClick={this.props.established ? this.props.onEndWebRTC : undefined}
          bsStyle={this.props.established ? 'danger' : 'success'}
          className={endClassName}
        >
          <B.Glyphicon glyph="earphone" />
        </B.Button>
        <span className="chat-audio-label">{this.label}</span>
      </div>
    );
  }
}

export default AudioChat;



// WEBPACK FOOTER //
// ./components/chat/webrtc/audio.js